<template>
  <router-view/>
</template>
<script>
export default {
  name: 'personasIndex'
}
</script>

<style scoped>

</style>
